import './style.scss';

import './blocks/carousel/view/index';

console.log(`[gridible] front.js loaded`)
